// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file file_service.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ListAvailableImagesRequest, ListAvailableImagesResponse, ListAvailableVideosRequest, ListAvailableVideosResponse, UploadImageRequest, UploadImageResponse, UploadVideoRequest, UploadVideoResponse } from "./file_service_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service cuda_learning.FileService
 */
export const FileService = {
  typeName: "cuda_learning.FileService",
  methods: {
    /**
     * @generated from rpc cuda_learning.FileService.ListAvailableImages
     */
    listAvailableImages: {
      name: "ListAvailableImages",
      I: ListAvailableImagesRequest,
      O: ListAvailableImagesResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.FileService.UploadImage
     */
    uploadImage: {
      name: "UploadImage",
      I: UploadImageRequest,
      O: UploadImageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc cuda_learning.FileService.ListAvailableVideos
     */
    listAvailableVideos: {
      name: "ListAvailableVideos",
      I: ListAvailableVideosRequest,
      O: ListAvailableVideosResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.FileService.UploadVideo
     */
    uploadVideo: {
      name: "UploadVideo",
      I: UploadVideoRequest,
      O: UploadVideoResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

